
// // // import React, { useEffect, useState } from 'react';
// // // import './EditDeletePublish.css';
// // // import axios from 'axios';
// // // import { useSelector } from 'react-redux';
// // // import { Modal, Button } from 'react-bootstrap';
// // // import { useNavigate } from 'react-router-dom';

// // // const EditDeletePublish = () => {
// // //   const [activeTab, setActiveTab] = useState("edit-delete");
// // //   const [projects, setProjects] = useState([]);
// // //   const [publishedProjects, setPublishedProjects] = useState([]);
// // //   const [underReviewProjects, setUnderReviewProjects] = useState([]);
// // //   const [loading, setLoading] = useState(true);
// // //   const [error, setError] = useState(null);
// // //   const [editProject, setEditProject] = useState(null);
// // //   const [disableActions, setDisableActions] = useState(false);
// // //   const user = useSelector((state) => state.User);
// // //   console.log(user)
// // //   const navigate = useNavigate();
// // //   const [len, setLen] = useState(0);
// // //   const backendURL = process.env.REACT_APP_backend_url;

// // //   // Fetch projects from the backend
// // //   const fetchProjects = async () => {
// // //     try {
// // //       const token = sessionStorage.getItem('Token');
// // //       const roll_id = user.currentUser.rollId;

// // //       const response = await axios.get(`${backendURL}/project/${roll_id}`, {
// // //         headers: {
// // //           'Content-Type': 'application/json',
// // //           'Authorization': `Bearer ${token}`,
// // //         },
// // //         withCredentials:true,
// // //       });

// // //       const projectData = Array.isArray(response.data) ? response.data : [];
// // //       // console.log(projectData);

// // //       // Update state with the latest data
// // //       setLen(projectData.length);
// // //       setProjects(projectData.filter(project => project.status === 'FALSE' && project.done_review === 'FALSE' && project.publish === 'FALSE' && project.under_review === 'FALSE'));
// // //       setPublishedProjects(projectData.filter(project => project.publish === 'TRUE' && project.under_review === 'FALSE'));
// // //       setUnderReviewProjects(projectData.filter(project => project.under_review === 'TRUE'));

// // //       setLoading(false);
// // //     } catch (error) {
      
// // //       setError('Failed to load projects.');
// // //       setLoading(false);
// // //     }
// // //   };
// // //   const deleteStudentFromProject = async (faculty_id, project_id, student_id) => {
// // //     try {
     
  
// // //       console.log('Deleting student with:', { faculty_id, project_id, student_id });
  
// // //       const response = await axios.delete(
// // //         `${backendURL}/faculty/${faculty_id}/project/${project_id}/student/${student_id}`,
// // //         {
// // //           headers: {
// // //             Authorization: `Bearer `,
// // //           },
// // //           withCredentials:true,
// // //         }
// // //       );
  
// // //       console.log('Student deleted successfully:', response.data);
  
// // //       // Refetch projects to update the UI
// // //       await fetchProjects();
// // //     } catch (error) {
// // //       console.error('Error deleting student:', error);
  
// // //       if (error.response) {
// // //         // The request was made and the server responded with a status code
// // //         console.error('Response data:', error.response.data);
// // //         console.error('Response status:', error.response.status);
// // //         console.error('Response headers:', error.response.headers);
// // //       } else if (error.request) {
// // //         // The request was made but no response was received
// // //         console.error('No response received:', error.request);
// // //       } else {
// // //         // Something happened in setting up the request
// // //         console.error('Error setting up the request:', error.message);
// // //       }
  
// // //       alert('Failed to delete student. Please check the console for details.');
// // //     }
// // //   };
// // //   // Fetch projects when the component mounts or when the user changes
// // //   useEffect(() => {
// // //     fetchProjects();
// // //   }, [user.currentUser.id]);

// // //   // Delete a project
// // //   const handleDelete = async (id) => {
// // //     try {
// // //       const token = sessionStorage.getItem('Token');
// // //       const response = await axios.delete(`${backendURL}/delete_project/${id}`, {
// // //         headers: {
// // //           'Content-Type': 'application/json',
// // //           'Authorization': `Bearer ${token}`,
// // //         },
// // //         withCredentials:true,
// // //       });

// // //       if (response.data.message === "Project deleted successfully!") {
// // //         // Refetch projects after deletion
// // //         await fetchProjects();
// // //       }
// // //     } catch (error) {
// // //       console.error('Error deleting the project:', error);
// // //     }
// // //   };

// // //   // Edit a project
// // //   const handleEdit = (project) => {
// // //     console.log(project)
// // //     setEditProject(project);
// // //   };

// // //   // Save edited project
// // //   const handleSave = async () => {
// // //     try {
// // //       let data={"project_data":editProject,"user_info":user.currentUser}
// // //       const token = sessionStorage.getItem('Token');
// // //       await axios.put(`${backendURL}/update_project`, data, {
// // //         headers: {
// // //           'Content-Type': 'application/json',
// // //           'Authorization': `Bearer ${token}`,
// // //         },
// // //         withCredentials:true
// // //       });

// // //       // Refetch projects after editing
// // //       await fetchProjects();
// // //       setEditProject(null);
// // //     } catch (error) {
// // //       console.error('Error updating the project:', error);
// // //       alert('Failed to update project.');
// // //     }
// // //   };

// // //   // Handle project review
// // //   const handleReview = async (project) => {
// // //     try {
// // //       const token = sessionStorage.getItem('Token');
// // //       // const currentUser = JSON.parse(localStorage.getItem('currentUser'));

// // //       setDisableActions(true);

// // //       const res = await axios.post(
// // //         `${backendURL}/under_review`,
// // //         {
// // //           under_review: true,
// // //           currentUser: user.currentUser,
// // //           project: project,
// // //         },
// // //         {
// // //           headers: {
// // //             'Content-Type': 'application/json',
// // //             'Authorization': `Bearer ${token}`,
// // //           },
// // //           withCredentials:true,
// // //         }
// // //       );

// // //       if (res.data.message === 'sent email wait for review!') {
// // //         project['under_review'] = 'true';
// // //         await axios.put(`${backendURL}/update_project`, [project, user.currentUser], {
// // //           headers: {
// // //             'Content-Type': 'application/json',
// // //             'Authorization': `Bearer ${token}`,
// // //           },
// // //         });

// // //         // Refetch projects after marking as under review
// // //         await fetchProjects();
// // //       }
// // //     } catch (error) {
// // //       console.error('Error marking the project as under review:', error);
// // //       alert('Failed to mark the project as under review.');
// // //     } finally {
// // //       setDisableActions(false);
// // //     }
// // //   };

// // //   // Navigate to the file upload page
// // //   const handleAddClick = () => {
// // //     navigate('/fileUpload');
// // //   };

// // //   // Navigate to the review page
// // //   const handleViewReviews = (project) => {
// // //     navigate(`/reviewPage/:${project['project_id']}`);
// // //   };

// // //   if (loading) return <div>Loading...</div>;
// // //   if (error) return <div>{error}</div>;

// // //   return (
// // //     <div className="edit-delete-publish-dashboard">
// // //       <h2 className="text-center text-2xl font-bold mb-6">PROJECTS</h2>
// // //       <p className="p3">Total Projects: {len}</p>
// // //       <div className="d-flex justify-content-between">
// // //         <button className="add text-white bg-success" onClick={handleAddClick} disabled={disableActions}>
// // //           ADD
// // //         </button>
// // //         <button className="research text-white bg-success" disabled={disableActions}>
// // //           Research
// // //         </button>
// // //       </div>

// // //       <div className="flex space-x-6 justify-center mb-6 mt-2">
// // //         <button
// // //           onClick={() => setActiveTab("edit-delete")}
// // //           className={`text-lg text-decoration-none font-semibold ${activeTab === "edit-delete" ? "text-blue-600 underline" : "text-gray-700"}`}
// // //         >
// // //           Edit/Delete
// // //         </button>
// // //         <button
// // //           onClick={() => setActiveTab("under-review")}
// // //           className={`text-lg text-decoration-none font-semibold ${activeTab === "under-review" ? "text-blue-600 underline" : "text-gray-700"}`}
// // //         >
// // //           Under Review
// // //         </button>
// // //         <button
// // //           onClick={() => setActiveTab("published-projects")}
// // //           className={`text-lg text-decoration-none font-semibold ${activeTab === "published-projects" ? "text-blue-600 underline" : "text-gray-700"}`}
// // //         >
// // //           Published Projects
// // //         </button>
// // //       </div>

// // //       <div className="bg-gray-100 p-6 rounded-md shadow-md">
// // //         {activeTab === "edit-delete" && (
// // //           <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
// // //             {projects.map((project) => (
// // //               <div key={project.Project_id} className="project-card1 slide-in">
// // //                 <div className="project-info">
// // //                   <h2 className="prot">
// // //                     <strong>{project.title}</strong>
// // //                   </h2>
// // //                   <p className="p3">
// // //                     <strong>Abstract:</strong> {project.abstract}
// // //                   </p>
// // //                   <p className="p3">
// // //                     <strong>Requirements:</strong> {project.requirements}
// // //                   </p>
// // //                   <p className="p3">
// // //                     <strong>Domain:</strong> {project.domain}
// // //                   </p>
// // //                   <p className="p3">
// // //                     <strong>Department:</strong> {project.department}
// // //                   </p>
// // //                   <ul>
// // //                     {project.students &&
// // //                       project.students.map((student) => (
// // //                         <li key={student.id}>
// // //                           {student.name} - {student.email} (ID: {student.student_id})
// // //                         </li>
// // //                       ))}
// // //                   </ul>
// // //                 </div>
// // //                 <div className="buttonns">
// // //                   <div className="project-actions1">
// // //                     <button onClick={() => handleEdit(project)} className="edit-btn">
// // //                       Edit
// // //                     </button>
// // //                     <button onClick={() => handleDelete(project.project_id)} className="delete-btn">
// // //                       Delete
// // //                     </button>
// // //                   </div>
// // //                   <div className="project-actions1">
// // //                     <button onClick={() => handleReview(project)} className="publish-btn">
// // //                       Review It
// // //                     </button>
// // //                   </div>
// // //                 </div>
// // //               </div>
// // //             ))}
// // //           </div>
// // //         )}

// // //         {activeTab === "under-review" && (
// // //           <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
// // //             {underReviewProjects.length > 0 ? (
// // //               underReviewProjects.map((project) => (
// // //                 <div key={project.Project_id} className="project-card slide-in">
// // //                   <div className="project-info reviews">
// // //                     <h2 className="prot">{project.title}</h2>
// // //                     {project.abstract && (
// // //                       <p className="p3">
// // //                         <strong>Abstract:</strong> {project.abstract}
// // //                       </p>
// // //                     )}
// // //                     {project.requirements && (
// // //                       <p className="p3">
// // //                         <strong>Requirements:</strong> {project.requirements}
// // //                       </p>
// // //                     )}
// // //                     {project.domain && (
// // //                       <p className="p3">
// // //                         <strong>Domain:</strong> {project.domain}
// // //                       </p>
// // //                     )}
// // //                     {project.department && (
// // //                       <p className="p3">
// // //                         <strong>Department:</strong> {project.department}
// // //                       </p>
// // //                     )}
// // //                     <button onClick={() => handleViewReviews(project)} className="button btn-success">
// // //                       View Reviews
// // //                     </button>
// // //                   </div>
// // //                 </div>
// // //               ))
// // //             ) : (
// // //               <h4>No Projects Under Review</h4>
// // //             )}
// // //           </div>
// // //         )}

// // //         {activeTab === "published-projects" && (
// // //           <div className="published-project-list">
// // //             {publishedProjects.length > 0 ? (
// // //               publishedProjects.map((project) => (
// // //                 <div key={project.project_id} className="project-card">
// // //                   <div className="project-info">
// // //                     <h2>{project.title}</h2>
// // //                     {project.abstract && (
// // //                       <p className="p3">
// // //                         <strong>Abstract:</strong> {project.abstract}
// // //                       </p>
// // //                     )}
// // //                     {project.requirements && (
// // //                       <p className="p3">
// // //                         <strong>Requirements:</strong> {project.requirements}
// // //                       </p>
// // //                     )}
// // //                     {project.domain && (
// // //                       <p className="p3">
// // //                         <strong>Domain:</strong> {project.domain}
// // //                       </p>
// // //                     )}
// // //                     {project.department && (
// // //                       <p className="p3">
// // //                         <strong>Department:</strong> {project.department}
// // //                       </p>
// // //                     )}
// // //                     {project.students && project.students.length > 0 ? (
// // //                       <>
// // //                         <p className="p3">
// // //                           <strong>Students:</strong>
// // //                         </p>
// // //                         <ul>
// // //                           {project.students.map((student) => (
// // //                             <div className="flex gap-3 text-lg" key={student.id}>
// // //                               <li>
// // //                                 {student.name} - {student.email} (ID: {student.student_id})
// // //                               </li>
// // //                               <button
// // //                                 className="bg-red-500 rounded-md p-2"
// // //                                 onClick={() =>
// // //                                   deleteStudentFromProject(user.currentUser.rollId, project.project_id, student.student_id)
// // //                                 }
// // //                               >
// // //                                 Delete
// // //                               </button>
// // //                             </div>
// // //                           ))}
// // //                         </ul>
// // //                       </>
// // //                     ) : (
// // //                       <p className="p3">
// // //                         <strong>Students:</strong> No students assigned
// // //                       </p>
// // //                     )}
// // //                     <div className="ppbutton d-flex justify-content-between">
// // //                       <button
// // //                         className="view-reviews"
// // //                         onClick={() => handleViewReviews(project)}
// // //                         disabled={disableActions}
// // //                       >
// // //                         View Reviews
// // //                       </button>
// // //                     </div>
// // //                   </div>
// // //                 </div>
// // //               ))
// // //             ) : (
// // //               <h4>No Published Projects</h4>
// // //             )}
// // //           </div>
// // //         )}
// // //       </div>

// // //       <Modal show={!!editProject} onHide={() => setEditProject(null)} centered>
// // //         <Modal.Header closeButton>
// // //           <Modal.Title>Edit Project</Modal.Title>
// // //         </Modal.Header>
// // //         <Modal.Body>
// // //           {editProject && (
// // //             <div className="project-edit-form">
// // //               <div className="form-group">
// // //                 <label>Title</label>
// // //                 <input
// // //                   type="text"
// // //                   name="title"
// // //                   className="form-control"
// // //                   value={editProject.title}
// // //                   onChange={(e) => setEditProject({ ...editProject, title: e.target.value })}
// // //                 />
// // //               </div>
// // //               <div className="form-group">
// // //                 <label>Abstract</label>
// // //                 <input
// // //                   type="text"
// // //                   name="abstract"
// // //                   className="form-control"
// // //                   value={editProject.abstract}
// // //                   onChange={(e) => setEditProject({ ...editProject, abstract: e.target.value })}
// // //                 />
// // //               </div>
// // //               <div className="form-group">
// // //                 <label>Requirements</label>
// // //                 <input
// // //                   type="text"
// // //                   name="requirements"
// // //                   className="form-control"
// // //                   value={editProject.requirements}
// // //                   onChange={(e) => setEditProject({ ...editProject, requirements: e.target.value })}
// // //                 />
// // //               </div>
// // //               <div className="form-group">
// // //                 <label>Domain</label>
// // //                 <input
// // //                   type="text"
// // //                   name="domain"
// // //                   className="form-control"
// // //                   value={editProject.domain}
// // //                   onChange={(e) => setEditProject({ ...editProject, domain: e.target.value })}
// // //                 />
// // //               </div>
// // //               <div className="form-group">
// // //                 <label>Department</label>
// // //                 <input
// // //                   type="text"
// // //                   name="department"
// // //                   className="form-control"
// // //                   value={editProject.department}
// // //                   onChange={(e) => setEditProject({ ...editProject, department: e.target.value })}
// // //                 />
// // //               </div>
// // //             </div>
// // //           )}
// // //         </Modal.Body>
// // //         <Modal.Footer>
// // //           <Button variant="secondary" onClick={() => setEditProject(null)}>
// // //             Cancel
// // //           </Button>
// // //           <Button variant="primary" onClick={handleSave}>
// // //             Save Changes
// // //           </Button>
// // //         </Modal.Footer>
// // //       </Modal>
// // //     </div>
// // //   );
// // // };

// // // export default EditDeletePublish;






// // // import React, { useEffect, useState } from 'react';
// // // import './EditDeletePublish.css';
// // // import axios from 'axios';
// // // import { useSelector } from 'react-redux';
// // // import { Modal, Button } from 'react-bootstrap';
// // // import { useNavigate } from 'react-router-dom';

// // // const EditDeletePublish = () => {
// // //   const [activeTab, setActiveTab] = useState("edit-delete");
// // //   const [projects, setProjects] = useState([]);
// // //   const [publishedProjects, setPublishedProjects] = useState([]);
// // //   const [underReviewProjects, setUnderReviewProjects] = useState([]);
// // //   const [loading, setLoading] = useState(true);
// // //   const [error, setError] = useState(null);
// // //   const [editProject, setEditProject] = useState(null);
// // //   const [disableActions, setDisableActions] = useState(false);
// // //   const user = useSelector((state) => state.User);
// // //   console.log(user)
// // //   const navigate = useNavigate();
// // //   const [len, setLen] = useState(0);
// // //   const backendURL = process.env.REACT_APP_backend_url;

// // //   // Fetch projects from the backend
// // //   const fetchProjects = async () => {
// // //     try {
// // //       const token = sessionStorage.getItem('Token');
// // //       const roll_id = user.currentUser.rollId;

// // //       const response = await axios.get(`${backendURL}/project/${roll_id}`, {
// // //         headers: {
// // //           'Content-Type': 'application/json',
// // //           'Authorization': `Bearer ${token}`,
// // //         },
// // //         withCredentials:true,
// // //       });

// // //       const projectData = Array.isArray(response.data) ? response.data : [];
// // //       // console.log(projectData);

// // //       // Update state with the latest data
// // //       setLen(projectData.length);
// // //       setProjects(projectData.filter(project => project.status === 'FALSE' && project.done_review === 'FALSE' && project.publish === 'FALSE' && project.under_review === 'FALSE'));
// // //       setPublishedProjects(projectData.filter(project => project.publish === 'TRUE' && project.under_review === 'FALSE'));
// // //       setUnderReviewProjects(projectData.filter(project => project.under_review === 'TRUE'));

// // //       setLoading(false);
// // //     } catch (error) {
      
// // //       setError('Failed to load projects.');
// // //       setLoading(false);
// // //     }
// // //   };
// // //   const deleteStudentFromProject = async (faculty_id, project_id, student_id) => {
// // //     try {
     
  
// // //       console.log('Deleting student with:', { faculty_id, project_id, student_id });
  
// // //       const response = await axios.delete(
// // //         `${backendURL}/faculty/${faculty_id}/project/${project_id}/student/${student_id}`,
// // //         {
// // //           headers: {
// // //             Authorization: `Bearer `,
// // //           },
// // //           withCredentials:true,
// // //         }
// // //       );
  
// // //       console.log('Student deleted successfully:', response.data);
  
// // //       // Refetch projects to update the UI
// // //       await fetchProjects();
// // //     } catch (error) {
// // //       console.error('Error deleting student:', error);
  
// // //       if (error.response) {
// // //         // The request was made and the server responded with a status code
// // //         console.error('Response data:', error.response.data);
// // //         console.error('Response status:', error.response.status);
// // //         console.error('Response headers:', error.response.headers);
// // //       } else if (error.request) {
// // //         // The request was made but no response was received
// // //         console.error('No response received:', error.request);
// // //       } else {
// // //         // Something happened in setting up the request
// // //         console.error('Error setting up the request:', error.message);
// // //       }
  
// // //       alert('Failed to delete student. Please check the console for details.');
// // //     }
// // //   };
// // //   // Fetch projects when the component mounts or when the user changes
// // //   useEffect(() => {
// // //     fetchProjects();
// // //   }, [user.currentUser.id]);

// // //   // Delete a project
// // //   const handleDelete = async (id) => {
// // //     try {
// // //       const token = sessionStorage.getItem('Token');
// // //       const response = await axios.delete(`${backendURL}/delete_project/${id}`, {
// // //         headers: {
// // //           'Content-Type': 'application/json',
// // //           'Authorization': `Bearer ${token}`,
// // //         },
// // //         withCredentials:true,
// // //       });

// // //       if (response.data.message === "Project deleted successfully!") {
// // //         // Refetch projects after deletion
// // //         await fetchProjects();
// // //       }
// // //     } catch (error) {
// // //       console.error('Error deleting the project:', error);
// // //     }
// // //   };

// // //   // Edit a project
// // //   const handleEdit = (project) => {
// // //     console.log(project)
// // //     setEditProject(project);
// // //   };

// // //   // Save edited project
// // //   const handleSave = async () => {
// // //     try {
// // //       let data={"project_data":editProject,"user_info":user.currentUser}
// // //       const token = sessionStorage.getItem('Token');
// // //       await axios.put(`${backendURL}/update_project`, data, {
// // //         headers: {
// // //           'Content-Type': 'application/json',
// // //           'Authorization': `Bearer ${token}`,
// // //         },
// // //         withCredentials:true
// // //       });

// // //       // Refetch projects after editing
// // //       await fetchProjects();
// // //       setEditProject(null);
// // //     } catch (error) {
// // //       console.error('Error updating the project:', error);
// // //       alert('Failed to update project.');
// // //     }
// // //   };

// // //   // Handle project review
// // //   const handleReview = async (project) => {
// // //     try {
// // //       const token = sessionStorage.getItem('Token');
// // //       // const currentUser = JSON.parse(localStorage.getItem('currentUser'));

// // //       setDisableActions(true);

// // //       const res = await axios.post(
// // //         `${backendURL}/under_review`,
// // //         {
// // //           under_review: true,
// // //           currentUser: user.currentUser,
// // //           project: project,
// // //         },
// // //         {
// // //           headers: {
// // //             'Content-Type': 'application/json',
// // //             'Authorization': `Bearer ${token}`,
// // //           },
// // //           withCredentials:true,
// // //         }
// // //       );

// // //       if (res.data.message === 'sent email wait for review!') {
// // //         project['under_review'] = 'true';
// // //         await axios.put(`${backendURL}/update_project`, [project, user.currentUser], {
// // //           headers: {
// // //             'Content-Type': 'application/json',
// // //             'Authorization': `Bearer ${token}`,
// // //           },
// // //         });

// // //         // Refetch projects after marking as under review
// // //         await fetchProjects();
// // //       }
// // //     } catch (error) {
// // //       console.error('Error marking the project as under review:', error);
// // //       alert('Failed to mark the project as under review.');
// // //     } finally {
// // //       setDisableActions(false);
// // //     }
// // //   };

// // //   // Navigate to the file upload page
// // //   const handleAddClick = () => {
// // //     navigate('/fileUpload');
// // //   };

// // //   // Navigate to the review page
// // //   const handleViewReviews = (project) => {
// // //     navigate(`/reviewPage/:${project['project_id']}`);
// // //   };

// // //   if (loading) return <div>Loading...</div>;
// // //   if (error) return <div>{error}</div>;

// // //   return (
// // //     <div className="edit-delete-publish-dashboard">
// // //       <h2 className="text-center text-2xl font-bold mb-6">PROJECTS</h2>
// // //       <p className="p3">Total Projects: {len}</p>
// // //       <div className="d-flex justify-content-between">
// // //         <button className="add text-white bg-success" onClick={handleAddClick} disabled={disableActions}>
// // //           ADD
// // //         </button>
// // //         <button className="research text-white bg-success" disabled={disableActions}>
// // //           Research
// // //         </button>
// // //       </div>

// // //       <div className="flex space-x-6 justify-center mb-6 mt-2">
// // //         <button
// // //           onClick={() => setActiveTab("edit-delete")}
// // //           className={`text-lg text-decoration-none font-semibold ${activeTab === "edit-delete" ? "text-blue-600 underline" : "text-gray-700"}`}
// // //         >
// // //           Edit/Delete
// // //         </button>
// // //         <button
// // //           onClick={() => setActiveTab("under-review")}
// // //           className={`text-lg text-decoration-none font-semibold ${activeTab === "under-review" ? "text-blue-600 underline" : "text-gray-700"}`}
// // //         >
// // //           Under Review
// // //         </button>
// // //         <button
// // //           onClick={() => setActiveTab("published-projects")}
// // //           className={`text-lg text-decoration-none font-semibold ${activeTab === "published-projects" ? "text-blue-600 underline" : "text-gray-700"}`}
// // //         >
// // //           Published Projects
// // //         </button>
// // //       </div>

// // //       <div className="bg-gray-100 p-6 rounded-md shadow-md">
// // //         {activeTab === "edit-delete" && (
// // //           <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
// // //             {projects.map((project) => (
// // //               <div key={project.Project_id} className="project-card1 slide-in">
// // //                 <div className="project-info">
// // //                   <h2 className="prot">
// // //                     <strong>{project.title}</strong>
// // //                   </h2>
// // //                   <p className="p3">
// // //                     <strong>Abstract:</strong> {project.abstract}
// // //                   </p>
// // //                   <p className="p3">
// // //                     <strong>Requirements:</strong> {project.requirements}
// // //                   </p>
// // //                   <p className="p3">
// // //                     <strong>Domain:</strong> {project.domain}
// // //                   </p>
// // //                   <p className="p3">
// // //                     <strong>Department:</strong> {project.department}
// // //                   </p>
// // //                   <ul>
// // //                     {project.students &&
// // //                       project.students.map((student) => (
// // //                         <li key={student.id}>
// // //                           {student.name} - {student.email} (ID: {student.student_id})
// // //                         </li>
// // //                       ))}
// // //                   </ul>
// // //                 </div>
// // //                 <div className="buttonns">
// // //                   <div className="project-actions1">
// // //                     <button onClick={() => handleEdit(project)} className="edit-btn">
// // //                       Edit
// // //                     </button>
// // //                     <button onClick={() => handleDelete(project.project_id)} className="delete-btn">
// // //                       Delete
// // //                     </button>
// // //                   </div>
// // //                   <div className="project-actions1">
// // //                     <button onClick={() => handleReview(project)} className="publish-btn">
// // //                       Review It
// // //                     </button>
// // //                   </div>
// // //                 </div>
// // //               </div>
// // //             ))}
// // //           </div>
// // //         )}

// // //         {activeTab === "under-review" && (
// // //           <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
// // //             {underReviewProjects.length > 0 ? (
// // //               underReviewProjects.map((project) => (
// // //                 <div key={project.Project_id} className="project-card slide-in">
// // //                   <div className="project-info reviews">
// // //                     <h2 className="prot">{project.title}</h2>
// // //                     {project.abstract && (
// // //                       <p className="p3">
// // //                         <strong>Abstract:</strong> {project.abstract}
// // //                       </p>
// // //                     )}
// // //                     {project.requirements && (
// // //                       <p className="p3">
// // //                         <strong>Requirements:</strong> {project.requirements}
// // //                       </p>
// // //                     )}
// // //                     {project.domain && (
// // //                       <p className="p3">
// // //                         <strong>Domain:</strong> {project.domain}
// // //                       </p>
// // //                     )}
// // //                     {project.department && (
// // //                       <p className="p3">
// // //                         <strong>Department:</strong> {project.department}
// // //                       </p>
// // //                     )}
// // //                     <button onClick={() => handleViewReviews(project)} className="button btn-success">
// // //                       View Reviews
// // //                     </button>
// // //                   </div>
// // //                 </div>
// // //               ))
// // //             ) : (
// // //               <h4>No Projects Under Review</h4>
// // //             )}
// // //           </div>
// // //         )}

// // //         {activeTab === "published-projects" && (
// // //           <div className="published-project-list">
// // //             {publishedProjects.length > 0 ? (
// // //               publishedProjects.map((project) => (
// // //                 <div key={project.project_id} className="project-card">
// // //                   <div className="project-info">
// // //                     <h2>{project.title}</h2>
// // //                     {project.abstract && (
// // //                       <p className="p3">
// // //                         <strong>Abstract:</strong> {project.abstract}
// // //                       </p>
// // //                     )}
// // //                     {project.requirements && (
// // //                       <p className="p3">
// // //                         <strong>Requirements:</strong> {project.requirements}
// // //                       </p>
// // //                     )}
// // //                     {project.domain && (
// // //                       <p className="p3">
// // //                         <strong>Domain:</strong> {project.domain}
// // //                       </p>
// // //                     )}
// // //                     {project.department && (
// // //                       <p className="p3">
// // //                         <strong>Department:</strong> {project.department}
// // //                       </p>
// // //                     )}
// // //                     {project.students && project.students.length > 0 ? (
// // //                       <>
// // //                         <p className="p3">
// // //                           <strong>Students:</strong>
// // //                         </p>
// // //                         <ul>
// // //                           {project.students.map((student) => (
// // //                             <div className="flex gap-3 text-lg" key={student.id}>
// // //                               <li>
// // //                                 {student.name} - {student.email} (ID: {student.student_id})
// // //                               </li>
// // //                               <button
// // //                                 className="bg-red-500 rounded-md p-2"
// // //                                 onClick={() =>
// // //                                   deleteStudentFromProject(user.currentUser.rollId, project.project_id, student.student_id)
// // //                                 }
// // //                               >
// // //                                 Delete
// // //                               </button>
// // //                             </div>
// // //                           ))}
// // //                         </ul>
// // //                       </>
// // //                     ) : (
// // //                       <p className="p3">
// // //                         <strong>Students:</strong> No students assigned
// // //                       </p>
// // //                     )}
// // //                     <div className="ppbutton d-flex justify-content-between">
// // //                       <button
// // //                         className="view-reviews"
// // //                         onClick={() => handleViewReviews(project)}
// // //                         disabled={disableActions}
// // //                       >
// // //                         View Reviews
// // //                       </button>
// // //                     </div>
// // //                   </div>
// // //                 </div>
// // //               ))
// // //             ) : (
// // //               <h4>No Published Projects</h4>
// // //             )}
// // //           </div>
// // //         )}
// // //       </div>

// // //       <Modal show={!!editProject} onHide={() => setEditProject(null)} centered>
// // //         <Modal.Header closeButton>
// // //           <Modal.Title>Edit Project</Modal.Title>
// // //         </Modal.Header>
// // //         <Modal.Body>
// // //           {editProject && (
// // //             <div className="project-edit-form">
// // //               <div className="form-group">
// // //                 <label>Title</label>
// // //                 <input
// // //                   type="text"
// // //                   name="title"
// // //                   className="form-control"
// // //                   value={editProject.title}
// // //                   onChange={(e) => setEditProject({ ...editProject, title: e.target.value })}
// // //                 />
// // //               </div>
// // //               <div className="form-group">
// // //                 <label>Abstract</label>
// // //                 <input
// // //                   type="text"
// // //                   name="abstract"
// // //                   className="form-control"
// // //                   value={editProject.abstract}
// // //                   onChange={(e) => setEditProject({ ...editProject, abstract: e.target.value })}
// // //                 />
// // //               </div>
// // //               <div className="form-group">
// // //                 <label>Requirements</label>
// // //                 <input
// // //                   type="text"
// // //                   name="requirements"
// // //                   className="form-control"
// // //                   value={editProject.requirements}
// // //                   onChange={(e) => setEditProject({ ...editProject, requirements: e.target.value })}
// // //                 />
// // //               </div>
// // //               <div className="form-group">
// // //                 <label>Domain</label>
// // //                 <input
// // //                   type="text"
// // //                   name="domain"
// // //                   className="form-control"
// // //                   value={editProject.domain}
// // //                   onChange={(e) => setEditProject({ ...editProject, domain: e.target.value })}
// // //                 />
// // //               </div>
// // //               <div className="form-group">
// // //                 <label>Department</label>
// // //                 <input
// // //                   type="text"
// // //                   name="department"
// // //                   className="form-control"
// // //                   value={editProject.department}
// // //                   onChange={(e) => setEditProject({ ...editProject, department: e.target.value })}
// // //                 />
// // //               </div>
// // //             </div>
// // //           )}
// // //         </Modal.Body>
// // //         <Modal.Footer>
// // //           <Button variant="secondary" onClick={() => setEditProject(null)}>
// // //             Cancel
// // //           </Button>
// // //           <Button variant="primary" onClick={handleSave}>
// // //             Save Changes
// // //           </Button>
// // //         </Modal.Footer>
// // //       </Modal>
// // //     </div>
// // //   );
// // // };

// // // export default EditDeletePublish;





// // import React, { useEffect, useState } from 'react';
// // import './EditDeletePublish.css';
// // import axios from 'axios';
// // import { useSelector } from 'react-redux';
// // import { Modal, Button } from 'react-bootstrap';
// // import { useNavigate } from 'react-router-dom';

// // const EditDeletePublish = () => {
// //   const [activeTab, setActiveTab] = useState("edit-delete");
// //   const [projects, setProjects] = useState([]);
// //   const [publishedProjects, setPublishedProjects] = useState([]);
// //   const [underReviewProjects, setUnderReviewProjects] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);
// //   const [editProject, setEditProject] = useState(null);
// //   const [disableActions, setDisableActions] = useState(false);
// //   const [notification, setNotification] = useState({ show: false, message: '', type: '' });
// //   const user = useSelector((state) => state.User);
// //   const navigate = useNavigate();
// //   const [len, setLen] = useState(0);
// //   const backendURL = process.env.REACT_APP_backend_url;

// //   // Function to show notification
// //   const showNotification = (message, type = 'success') => {
// //     setNotification({ show: true, message, type });
// //     setTimeout(() => {
// //       setNotification({ show: false, message: '', type: '' });
// //     }, 3000);
// //   };

// //   // Fetch projects from the backend
// //   const fetchProjects = async () => {
// //     try {
// //       setLoading(true);
// //       const token = sessionStorage.getItem('Token');
// //       const roll_id = user.currentUser.rollId;

// //       const response = await axios.get(`${backendURL}/project/${roll_id}`, {
// //         headers: {
// //           'Content-Type': 'application/json',
// //           'Authorization': `Bearer ${token}`,
// //         },
// //         withCredentials: true,
// //       });

// //       const projectData = Array.isArray(response.data) ? response.data : [];

// //       // Update state with the latest data
// //       setLen(projectData.length);
// //       setProjects(projectData.filter(project => project.status === 'FALSE' && project.done_review === 'FALSE' && project.publish === 'FALSE' && project.under_review === 'FALSE'));
// //       setPublishedProjects(projectData.filter(project => project.publish === 'TRUE' && project.under_review === 'FALSE'));
// //       setUnderReviewProjects(projectData.filter(project => project.under_review === 'TRUE'));
      
// //       setLoading(false);
// //     } catch (error) {
// //       console.error('Error fetching projects:', error);
// //       setError('Failed to load projects.');
// //       setLoading(false);
// //     }
// //   };

// //   const deleteStudentFromProject = async (faculty_id, project_id, student_id) => {
// //     try {
// //       setDisableActions(true);
      
// //       console.log('Deleting student with:', { faculty_id, project_id, student_id });
  
// //       const token = sessionStorage.getItem('Token');
// //       const response = await axios.delete(
// //         `${backendURL}/faculty/${faculty_id}/project/${project_id}/student/${student_id}`,
// //         {
// //           headers: {
// //             Authorization: `Bearer ${token}`,
// //           },
// //           withCredentials: true,
// //         }
// //       );
  
// //       console.log('Student deleted successfully:', response.data);
// //       showNotification('Student removed successfully');
      
// //       // Update the project list without a complete refetch
// //       setPublishedProjects(prevProjects => 
// //         prevProjects.map(project => {
// //           if (project.project_id === project_id) {
// //             return {
// //               ...project,
// //               students: project.students.filter(student => student.student_id !== student_id)
// //             };
// //           }
// //           return project;
// //         })
// //       );
// //     } catch (error) {
// //       console.error('Error deleting student:', error);
// //       showNotification('Failed to delete student', 'error');
// //     } finally {
// //       setDisableActions(false);
// //     }
// //   };

// //   // Fetch projects when the component mounts or when the user changes
// //   useEffect(() => {
// //     fetchProjects();
// //   }, [user.currentUser.id]);

// //   // Delete a project
// //   const handleDelete = async (id) => {
// //     try {
// //       setDisableActions(true);
// //       const token = sessionStorage.getItem('Token');
// //       const response = await axios.delete(`${backendURL}/delete_project/${id}`, {
// //         headers: {
// //           'Content-Type': 'application/json',
// //           'Authorization': `Bearer ${token}`,
// //         },
// //         withCredentials: true,
// //       });

// //       if (response.data.message === "Project deleted successfully!") {
// //         // Update projects state directly instead of refetching
// //         setProjects(prevProjects => prevProjects.filter(project => project.project_id !== id));
// //         setLen(prevLen => prevLen - 1);
// //         showNotification('Project deleted successfully');
// //       }
// //     } catch (error) {
// //       console.error('Error deleting the project:', error);
// //       showNotification('Failed to delete project', 'error');
// //     } finally {
// //       setDisableActions(false);
// //     }
// //   };

// //   // Edit a project
// //   const handleEdit = (project) => {
// //     setEditProject({...project});
// //   };

// //   // Cancel editing
// //   const handleCancelEdit = () => {
// //     setEditProject(null);
// //   };

// //   // Save edited project
// //   const handleSave = async () => {
// //     try {
// //       setDisableActions(true);
// //       let data = {"project_data": editProject, "user_info": user.currentUser};
// //       const token = sessionStorage.getItem('Token');
      
// //       const response = await axios.put(`${backendURL}/update_project`, data, {
// //         headers: {
// //           'Content-Type': 'application/json',
// //           'Authorization': `Bearer ${token}`,
// //         },
// //         withCredentials: true
// //       });

// //       // Update the project in the state directly
// //       setProjects(prevProjects => 
// //         prevProjects.map(project => 
// //           project.project_id === editProject.project_id ? editProject : project
// //         )
// //       );
      
// //       setEditProject(null);
// //       showNotification('Project updated successfully');
// //     } catch (error) {
// //       console.error('Error updating the project:', error);
// //       showNotification('Failed to update project', 'error');
// //     } finally {
// //       setDisableActions(false);
// //     }
// //   };

// //   // Handle project review
// //   const handleReview = async (project) => {
// //     try {
// //       setDisableActions(true);
// //       const token = sessionStorage.getItem('Token');

// //       const res = await axios.post(
// //         `${backendURL}/under_review`,
// //         {
// //           under_review: true,
// //           currentUser: user.currentUser,
// //           project: project,
// //         },
// //         {
// //           headers: {
// //             'Content-Type': 'application/json',
// //             'Authorization': `Bearer ${token}`,
// //           },
// //           withCredentials: true,
// //         }
// //       );

// //       if (res.data.message === 'sent email wait for review!') {
// //         // Update local state
// //         const updatedProject = { ...project, under_review: 'TRUE' };
        
// //         // Remove from projects and add to underReviewProjects
// //         setProjects(prevProjects => prevProjects.filter(p => p.project_id !== project.project_id));
// //         setUnderReviewProjects(prevProjects => [...prevProjects, updatedProject]);
        
// //         showNotification('Project sent for review');
// //       }
// //     } catch (error) {
// //       console.error('Error marking the project as under review:', error);
// //       showNotification('Failed to send project for review', 'error');
// //     } finally {
// //       setDisableActions(false);
// //     }
// //   };

  
// //   // Navigate to the file upload page
// //   const handleAddClick = () => {
// //     navigate('/fileUpload');
// //   };

// //   // Navigate to the review page
// //   const handleViewReviews = (project) => {
// //     navigate(`/reviewPage/:${project['project_id']}`);
// //     window.location.reload();

// //   };


// //   if (loading) return (
// //     <div className="loading-container">
// //       <div className="spinner"></div>
// //       <p>Loading projects...</p>
// //     </div>
// //   );
  
// //   if (error) return (
// //     <div className="error-message">
// //       <p>{error}</p>
// //       <button onClick={fetchProjects} className="retry-btn">Retry</button>
// //     </div>
// //   );

// //   return (
// //     <div className="edit-delete-publish-dashboard">
// //       {notification.show && (
// //         <div className={`notification ${notification.type}`}>
// //           {notification.message}
// //         </div>
// //       )}

// //       <h2 className="text-center text-2xl font-bold mb-6">PROJECTS</h2>
// //       <p className="p3">Total Projects: {len}</p>
// //       <div className="d-flex justify-content-between">
// //         <button className="add text-white bg-success" onClick={handleAddClick} disabled={disableActions}>
// //           ADD
// //         </button>
// //         <button className="research text-white bg-success" disabled={disableActions}>
// //           Research
// //         </button>
// //       </div>

// //       <div className="flex space-x-6 justify-center mb-6 mt-2">
// //         <button
// //           onClick={() => setActiveTab("edit-delete")}
// //           className={`text-lg text-decoration-none font-semibold ${activeTab === "edit-delete" ? "text-blue-600 underline" : "text-gray-700"}`}
// //         >
// //           Edit/Delete
// //         </button>
// //         <button
// //           onClick={() => setActiveTab("under-review")}
// //           className={`text-lg text-decoration-none font-semibold ${activeTab === "under-review" ? "text-blue-600 underline" : "text-gray-700"}`}
// //         >
// //           Under Review
// //         </button>
// //         <button
// //           onClick={() => setActiveTab("published-projects")}
// //           className={`text-lg text-decoration-none font-semibold ${activeTab === "published-projects" ? "text-blue-600 underline" : "text-gray-700"}`}
// //         >
// //           Published Projects
// //         </button>
// //       </div>

// //       <div className="bg-gray-100 p-6 rounded-md shadow-md">
// //         {activeTab === "edit-delete" && (
// //           <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
// //             {projects.length > 0 ? (
// //               projects.map((project) => (
// //                 <div key={project.project_id} className="project-card1 slide-in">
// //                   <div className="project-info">
// //                     <h2 className="prot">
// //                       <strong>{project.title}</strong>
// //                     </h2>
// //                     <p className="p3">
// //                       <strong>Abstract:</strong> {project.abstract}
// //                     </p>
// //                     <p className="p3">
// //                       <strong>Requirements:</strong> {project.requirements}
// //                     </p>
// //                     <p className="p3">
// //                       <strong>Domain:</strong> {project.domain}
// //                     </p>
// //                     <p className="p3">
// //                       <strong>Department:</strong> {project.department}
// //                     </p>
// //                     {project.students && project.students.length > 0 ? (
// //                       <ul>
// //                         {project.students.map((student) => (
// //                           <li key={student.id}>
// //                             {student.name} - {student.email} (ID: {student.student_id})
// //                           </li>
// //                         ))}
// //                       </ul>
// //                     ) : (
// //                       <p className="p3">No students assigned to this project.</p>
// //                     )}
// //                   </div>
// //                   <div className="buttonns">
// //                     <div className="project-actions1">
// //                       <button onClick={() => handleEdit(project)} className="edit-btn" disabled={disableActions}>
// //                         Edit
// //                       </button>
// //                       <button onClick={() => handleDelete(project.project_id)} className="delete-btn" disabled={disableActions}>
// //                         Delete
// //                       </button>
// //                     </div>
// //                     <div className="project-actions1">
// //   <button
// //     onClick={() => handleReview(project)}
// //     className="publish-btn"
// //     disabled={disableActions}
// //   >
// //     Review It
// //   </button>
// // </div>



// //                     {/* <div className="project-actions1">
// //                       <button onClick={() => handleReview(project)} className="publish-btn" disabled={disableActions}>
// //                         Review It
// //                       </button>
// //                     </div> */}
// //                   </div>
// //                 </div>
// //               ))
// //             ) : (
// //               <div className="no-projects">
// //                 <h3>No Projects Available</h3>
// //                 <p>Click the ADD button to create a new project.</p>
// //               </div>
// //             )}
// //           </div>
// //         )}

// //         {activeTab === "under-review" && (
// //           <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
// //             {underReviewProjects.length > 0 ? (
// //               underReviewProjects.map((project) => (
// //                 <div key={project.project_id} className="project-card slide-in">
// //                   <div className="project-info reviews">
// //                     <h2 className="prot">{project.title}</h2>
// //                     {project.abstract && (
// //                       <p className="p3">
// //                         <strong>Abstract:</strong> {project.abstract}
// //                       </p>
// //                     )}
// //                     {project.requirements && (
// //                       <p className="p3">
// //                         <strong>Requirements:</strong> {project.requirements}
// //                       </p>
// //                     )}
// //                     {project.domain && (
// //                       <p className="p3">
// //                         <strong>Domain:</strong> {project.domain}
// //                       </p>
// //                     )}
// //                     {project.department && (
// //                       <p className="p3">
// //                         <strong>Department:</strong> {project.department}
// //                       </p>
// //                     )}
// //                     <button onClick={() => handleViewReviews(project)} className="button btn-success" disabled={disableActions}>
// //                       View Reviews
// //                     </button>
// //                   </div>
// //                 </div>
// //               ))
// //             ) : (
// //               <div className="no-projects">
// //                 <h3>No Projects Under Review</h3>
// //                 <p>Submit projects for review from the Edit/Delete tab.</p>
// //               </div>
// //             )}
// //           </div>
// //         )}

// //         {activeTab === "published-projects" && (
// //           <div className="published-project-list">
// //             {publishedProjects.length > 0 ? (
// //               publishedProjects.map((project) => (
// //                 <div key={project.project_id} className="project-card">
// //                   <div className="project-info">
// //                     <h2 className="prot">{project.title}</h2>
// //                     {project.abstract && (
// //                       <p className="p3">
// //                         <strong>Abstract:</strong> {project.abstract}
// //                       </p>
// //                     )}
// //                     {project.requirements && (
// //                       <p className="p3">
// //                         <strong>Requirements:</strong> {project.requirements}
// //                       </p>
// //                     )}
// //                     {project.domain && (
// //                       <p className="p3">
// //                         <strong>Domain:</strong> {project.domain}
// //                       </p>
// //                     )}
// //                     {project.department && (
// //                       <p className="p3">
// //                         <strong>Department:</strong> {project.department}
// //                       </p>
// //                     )}
// //                     {project.students && project.students.length > 0 ? (
// //                       <>
// //                         <p className="p3">
// //                           <strong>Students:</strong>
// //                         </p>
// //                         <ul>
// //                           {project.students.map((student) => (
// //                             <div className="flex gap-3 text-lg" key={student.id}>
// //                               <li>
// //                                 {student.name} - {student.email} (ID: {student.student_id})
// //                               </li>
// //                               <button
// //                                 className="bg-red-500 rounded-md p-2"
// //                                 onClick={() => deleteStudentFromProject(user.currentUser.rollId, project.project_id, student.student_id)}
// //                                 disabled={disableActions}
// //                               >
// //                                 Delete
// //                               </button>
// //                             </div>
// //                           ))}
// //                         </ul>
// //                       </>
// //                     ) : (
// //                       <p className="p3">
// //                         <strong>Students:</strong> No students assigned
// //                       </p>
// //                     )}
// //                     <div className="ppbutton d-flex justify-content-between">
// //                       <button
// //                         className="view-reviews"
// //                         onClick={() => handleViewReviews(project)}
// //                         disabled={disableActions}
// //                       >
// //                         View Reviews
// //                       </button>
// //                     </div>
// //                   </div>
// //                 </div>
// //               ))
// //             ) : (
// //               <div className="no-projects">
// //                 <h3>No Published Projects</h3>
// //                 <p>Projects that pass review will appear here.</p>
// //               </div>
// //             )}
// //           </div>
// //         )}
// //       </div>

// //       <Modal show={!!editProject} onHide={handleCancelEdit} centered>
// //         <Modal.Header closeButton>
// //           <Modal.Title>Edit Project</Modal.Title>
// //         </Modal.Header>
// //         <Modal.Body>
// //           {editProject && (
// //             <div className="project-edit-form">
// //               <div className="form-group">
// //                 <label>Title</label>
// //                 <input
// //                   type="text"
// //                   name="title"
// //                   className="form-control"
// //                   value={editProject.title}
// //                   onChange={(e) => setEditProject({ ...editProject, title: e.target.value })}
// //                 />
// //               </div>
// //               <div className="form-group">
// //                 <label>Abstract</label>
// //                 <textarea
// //                   name="abstract"
// //                   className="form-control"
// //                   value={editProject.abstract}
// //                   onChange={(e) => setEditProject({ ...editProject, abstract: e.target.value })}
// //                   rows="3"
// //                 ></textarea>
// //               </div>
// //               <div className="form-group">
// //                 <label>Requirements</label>
// //                 <input
// //                   type="text"
// //                   name="requirements"
// //                   className="form-control"
// //                   value={editProject.requirements}
// //                   onChange={(e) => setEditProject({ ...editProject, requirements: e.target.value })}
// //                 />
// //               </div>
// //               <div className="form-group">
// //                 <label>Domain</label>
// //                 <input
// //                   type="text"
// //                   name="domain"
// //                   className="form-control"
// //                   value={editProject.domain}
// //                   onChange={(e) => setEditProject({ ...editProject, domain: e.target.value })}
// //                 />
// //               </div>
// //               <div className="form-group">
// //                 <label>Department</label>
// //                 <input
// //                   type="text"
// //                   name="department"
// //                   className="form-control"
// //                   value={editProject.department}
// //                   onChange={(e) => setEditProject({ ...editProject, department: e.target.value })}
// //                 />
// //               </div>
// //             </div>
// //           )}
// //         </Modal.Body>
// //         <Modal.Footer>
// //           <Button variant="secondary" onClick={handleCancelEdit}>
// //             Cancel
// //           </Button>
// //           <Button variant="primary" onClick={handleSave} disabled={disableActions}>
// //             Save Changes
// //           </Button>
// //         </Modal.Footer>
// //       </Modal>
// //     </div>
// //   );
// // };

// // export default EditDeletePublish;


// import React, { useEffect, useState } from 'react';
// import './EditDeletePublish.css';
// import axios from 'axios';
// import { useSelector } from 'react-redux';
// import { Modal, Button } from 'react-bootstrap';
// import { useNavigate } from 'react-router-dom';

// const EditDeletePublish = () => {
//   const [activeTab, setActiveTab] = useState("edit-delete");
//   const [projects, setProjects] = useState([]);
//   const [publishedProjects, setPublishedProjects] = useState([]);
//   const [underReviewProjects, setUnderReviewProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [editProject, setEditProject] = useState(null);
//   const [deleteConfirmModal, setDeleteConfirmModal] = useState({ show: false, id: null });
//   const [disableActions, setDisableActions] = useState(false);
//   const [notification, setNotification] = useState({ show: false, message: '', type: '' });
//   const user = useSelector((state) => state.User);
//   const navigate = useNavigate();
//   const backendURL = process.env.REACT_APP_backend_url;

//   // Notification utility
//   const showNotification = (message, type = 'success') => {
//     setNotification({ show: true, message, type });
//     setTimeout(() => setNotification({ show: false, message: '', type: '' }), 3000);
//   };

//   // Fetch all projects
//   const fetchProjects = async () => {
//     try {
//       setLoading(true);
//       const token = sessionStorage.getItem('Token');
//       const roll_id = user.currentUser.rollId;
//       const response = await axios.get(`${backendURL}/project/${roll_id}`, {
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${token}`,
//         },
//         withCredentials: true,
//       });

//       const projectData = Array.isArray(response.data) ? response.data : [];

//       setProjects(projectData.filter(p =>
//         p.status === 'FALSE' && p.done_review === 'FALSE' &&
//         p.publish === 'FALSE' && p.under_review === 'FALSE'
//       ));
//       setPublishedProjects(projectData.filter(p => p.publish === 'TRUE'));
//       setUnderReviewProjects(projectData.filter(p => p.under_review === 'TRUE'));

//       setLoading(false);
//     } catch (err) {
//       console.error('Error fetching projects:', err);
//       setError('Failed to load projects.');
//       setLoading(false);
//     }
//   };

//   // Delete student from a published project
//   const deleteStudentFromProject = async (faculty_id, project_id, student_id) => {
//     try {
//       setDisableActions(true);
//       const token = sessionStorage.getItem('Token');
//       const res = await axios.delete(
//         `${backendURL}/faculty/${faculty_id}/project/${project_id}/student/${student_id}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//           withCredentials: true,
//         }
//       );

//       if (res.status === 200) {
//         setPublishedProjects(prev =>
//           prev.map(project =>
//             project.project_id === project_id
//               ? {
//                   ...project,
//                   students: project.students.filter(s => s.student_id !== student_id)
//                 }
//               : project
//           )
//         );
//         showNotification('Student removed successfully');
//       }
//     } catch (err) {
//       console.error('Error deleting student:', err);
//       showNotification('Failed to remove student', 'error');
//     } finally {
//       setDisableActions(false);
//     }
//   };

//   // Handle component mount
//   useEffect(() => {
//     fetchProjects();
//   }, [user.currentUser.id]);

//   // Delete project
//   const handleDelete = async (id) => {
//     try {
//       setDisableActions(true);
//       const token = sessionStorage.getItem('Token');
//       const res = await axios.delete(`${backendURL}/delete_project/${id}`, {
//         headers: {
//           'Content-Type': 'application/json',
          
//         },
//         withCredentials: true,
//       });

//       if (res.data.message === "Project deleted successfully!") {
//         setProjects(projects.filter(p => p.project_id !== id));
//         showNotification('Project deleted successfully');
//       }

//       setDeleteConfirmModal({ show: false, id: null });
//     } catch (err) {
//       console.error('Error deleting project:', err);
//       showNotification('Failed to delete project', 'error');
//     } finally {
//       setDisableActions(false);
//     }
//   };

//   // Edit project
//   const handleEdit = (project) => setEditProject({ ...project });

//   // Cancel edit
//   const handleCancelEdit = () => setEditProject(null);

//   // Save edited project
//   const handleSave = async () => {
//     try {
//       setDisableActions(true);
//       const token = sessionStorage.getItem('Token');
//       const data = { project_data: editProject, user_info: user.currentUser };
//       const res = await axios.put(`${backendURL}/update_project`, data, {
//         headers: {
//           'Content-Type': 'application/json',
         
//         },
//         withCredentials: true,
//       });

//       if (res.status === 200) {
//         setProjects(prev => prev.map(p => p.project_id === editProject.project_id ? editProject : p));
//         setEditProject(null);
//         showNotification('Project updated successfully');
//       }
//     } catch (err) {
//       console.error('Error saving project:', err);
//       showNotification('Failed to update project', 'error');
//     } finally {
//       setDisableActions(false);
//     }
//   };

//   // Send project for review
//   const handleReview = async (project) => {
//     try {
//       setDisableActions(true);
//       const token = sessionStorage.getItem('Token');
//       const res = await axios.post(
//         `${backendURL}/under_review`,
//         {
//           under_review: true,
//           currentUser: user.currentUser,
//           project: project,
//         },
//         {
//           headers: {
//             'Content-Type': 'application/json',
           
//           },
//           withCredentials: true,
//         }
//       );

//       if (res.data.message === 'sent email wait for review!') {
//         const updatedProject = { ...project, under_review: 'TRUE' };
//         setProjects(prev => prev.filter(p => p.project_id !== project.project_id));
//         setUnderReviewProjects(prev => [...prev, updatedProject]);
//         showNotification('Project sent for review');
//       }
//     } catch (err) {
//       console.error('Error marking as under review:', err);
//       showNotification('Failed to send for review', 'error');
//     } finally {
//       setDisableActions(false);
//     }
//   };

//   // Navigate to upload page
//   const handleAddClick = () => navigate('/fileUpload');

//   // Navigate to review page
//   const handleViewReviews = (project) => {
//     navigate(`/reviewPage/${project.project_id}`);
//   };

//   return (
//     <div className="edit-delete-publish-dashboard">
//       {/* Notifications */}
//       {notification.show && (
//         <div className={`notification ${notification.type}`}>
//           {notification.message}
//         </div>
//       )}

//       {/* Header */}
//       <h2 className="text-center text-2xl font-bold mb-6">PROJECTS</h2>
//       <p className="p3">Total Projects: {projects.length}</p>

//       {/* Add & Research buttons */}
//       <div className="d-flex justify-content-between">
//         <button className="add text-white bg-success" onClick={handleAddClick} disabled={disableActions}>
//           ADD
//         </button>
//         <button className="research text-white bg-success" disabled={disableActions}>
//           Research
//         </button>
//       </div>

//       {/* Tabs */}
//       <div className="flex space-x-6 justify-center mb-6 mt-2">
//         {['edit-delete', 'under-review', 'published-projects'].map(tab => (
//           <button
//             key={tab}
//             onClick={() => setActiveTab(tab)}
//             className={`text-lg font-semibold ${
//               activeTab === tab ? "text-blue-600 underline" : "text-gray-700"
//             }`}
//           >
//             {tab.replace('-', ' ').toUpperCase()}
//           </button>
//         ))}
//       </div>

//       {/* Tab Content */}
//       <div className="bg-gray-100 p-6 rounded-md shadow-md">
//         {/* Edit/Delete Tab */}
//         {activeTab === "edit-delete" && (
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
//             {projects.length > 0 ? (
//               projects.map((project) => (
//                 <div key={project.project_id} className="project-card1 slide-in">
//                   {/* Project Info */}
//                   <div className="project-info">
//                     <h2><strong>{project.title}</strong></h2>
//                     <p><strong>Abstract:</strong> {project.abstract}</p>
//                     <p><strong>Requirements:</strong> {project.requirements}</p>
//                     <p><strong>Domain:</strong> {project.domain}</p>
//                     <p><strong>Department:</strong> {project.department}</p>
//                     {/* Students */}
//                     {project.students?.length > 0 ? (
//                       <ul>
//                         {project.students.map(student => (
//                           <li key={student.id}>
//                             {student.name} - {student.email} (ID: {student.student_id})
//                           </li>
//                         ))}
//                       </ul>
//                     ) : (
//                       <p>No students assigned.</p>
//                     )}
//                   </div>

//                   {/* Actions */}
//                   <div className="buttonns">
//                     <div className="project-actions1">
//                       <button onClick={() => handleEdit(project)} className="edit-btn" disabled={disableActions}>
//                         Edit
//                       </button>
//                       <button
//                         onClick={() => setDeleteConfirmModal({ show: true, id: project.project_id })}
//                         className="delete-btn"
//                         disabled={disableActions}
//                       >
//                         Delete
//                       </button>
//                     </div>
//                     <div className="project-actions1">
//                       <button
//                         onClick={() => handleReview(project)}
//                         className="publish-btn"
//                         disabled={disableActions}
//                       >
//                         Review It
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <div className="no-projects">
//                 <h3>No Projects Available</h3>
//                 <p>Click the ADD button to create a new project.</p>
//               </div>
//             )}
//           </div>
//         )}

//         {/* Under Review Tab */}
//         {activeTab === "under-review" && (
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
//             {underReviewProjects.length > 0 ? (
//               underReviewProjects.map((project) => (
//                 <div key={project.project_id} className="project-card slide-in">
//                   <div className="project-info reviews">
//                     <h2>{project.title}</h2>
//                     {project.abstract && <p><strong>Abstract:</strong> {project.abstract}</p>}
//                     {project.requirements && <p><strong>Requirements:</strong> {project.requirements}</p>}
//                     {project.domain && <p><strong>Domain:</strong> {project.domain}</p>}
//                     {project.department && <p><strong>Department:</strong> {project.department}</p>}
//                     <button
//                       onClick={() => handleViewReviews(project)}
//                       className="button btn-success"
//                       disabled={disableActions}
//                     >
//                       View Reviews
//                     </button>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <div className="no-projects">
//                 <h3>No Projects Under Review</h3>
//                 <p>Submit projects for review from the Edit/Delete tab.</p>
//               </div>
//             )}
//           </div>
//         )}

//         {/* Published Projects Tab */}
//         {activeTab === "published-projects" && (
//           <div className="published-project-list">
//             {publishedProjects.length > 0 ? (
//               publishedProjects.map((project) => (
//                 <div key={project.project_id} className="project-card">
//                   <div className="project-info">
//                     <h2>{project.title}</h2>
//                     {project.abstract && <p><strong>Abstract:</strong> {project.abstract}</p>}
//                     {project.requirements && <p><strong>Requirements:</strong> {project.requirements}</p>}
//                     {project.domain && <p><strong>Domain:</strong> {project.domain}</p>}
//                     {project.department && <p><strong>Department:</strong> {project.department}</p>}
//                     {project.students?.length > 0 ? (
//                       <>
//                         <p><strong>Students:</strong></p>
//                         <ul>
//                           {project.students.map((student) => (
//                             <div key={student.id} className="flex gap-3 text-lg">
//                               <li>
//                                 {student.name} - {student.email} (ID: {student.student_id})
//                               </li>
//                               <button
//                                 className="bg-red-500 rounded-md p-2"
//                                 onClick={() => deleteStudentFromProject(user.currentUser.rollId, project.project_id, student.student_id)}
//                                 disabled={disableActions}
//                               >
//                                 Delete
//                               </button>
//                             </div>
//                           ))}
//                         </ul>
//                       </>
//                     ) : (
//                       <p><strong>Students:</strong> No students assigned</p>
//                     )}
//                     <button
//                       className="view-reviews"
//                       onClick={() => handleViewReviews(project)}
//                       disabled={disableActions}
//                     >
//                       View Reviews
//                     </button>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <div className="no-projects">
//                 <h3>No Published Projects</h3>
//                 <p>Projects that pass review will appear here.</p>
//               </div>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Edit Modal */}
//       <Modal show={!!editProject} onHide={handleCancelEdit} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Project</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {editProject && (
//             <div className="project-edit-form">
//               <div className="form-group">
//                 <label>Title</label>
//                 <input
//                   type="text"
//                   name="title"
//                   value={editProject.title}
//                   onChange={(e) => setEditProject({ ...editProject, title: e.target.value })}
//                   className="form-control"
//                 />
//               </div>
//               <div className="form-group">
//                 <label>Abstract</label>
//                 <textarea
//                   name="abstract"
//                   value={editProject.abstract}
//                   onChange={(e) => setEditProject({ ...editProject, abstract: e.target.value })}
//                   rows="3"
//                   className="form-control"
//                 />
//               </div>
//               <div className="form-group">
//                 <label>Requirements</label>
//                 <input
//                   type="text"
//                   name="requirements"
//                   value={editProject.requirements}
//                   onChange={(e) => setEditProject({ ...editProject, requirements: e.target.value })}
//                   className="form-control"
//                 />
//               </div>
//               <div className="form-group">
//                 <label>Domain</label>
//                 <input
//                   type="text"
//                   name="domain"
//                   value={editProject.domain}
//                   onChange={(e) => setEditProject({ ...editProject, domain: e.target.value })}
//                   className="form-control"
//                 />
//               </div>
//               <div className="form-group">
//                 <label>Department</label>
//                 <input
//                   type="text"
//                   name="department"
//                   value={editProject.department}
//                   onChange={(e) => setEditProject({ ...editProject, department: e.target.value })}
//                   className="form-control"
//                 />
//               </div>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCancelEdit} disabled={disableActions}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleSave} disabled={disableActions}>
//             Save Changes
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Delete Confirmation Modal */}
//       <Modal show={deleteConfirmModal.show} onHide={() => setDeleteConfirmModal({ show: false, id: null })} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Deletion</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Are you sure you want to delete this project?
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setDeleteConfirmModal({ show: false, id: null })}>
//             Cancel
//           </Button>
//           <Button variant="danger" onClick={() => handleDelete(deleteConfirmModal.id)} disabled={disableActions}>
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default EditDeletePublish;





import React, { useEffect, useState } from 'react';
import './EditDeletePublish.css';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const EditDeletePublish = () => {
  const [activeTab, setActiveTab] = useState("draft-projects");
  const [projects, setProjects] = useState([]);
  const [publishedProjects, setPublishedProjects] = useState([]);
  const [underReviewProjects, setUnderReviewProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editProject, setEditProject] = useState(null);
  const [deleteConfirmModal, setDeleteConfirmModal] = useState({ show: false, id: null });
  const [disableActions, setDisableActions] = useState(false);
  const [notification, setNotification] = useState({ show: false, message: '', type: '' });
  const user = useSelector((state) => state.User);
  const navigate = useNavigate();
  const backendURL = process.env.REACT_APP_backend_url;

  // Notification utility
  const showNotification = (message, type = 'success') => {
    setNotification({ show: true, message, type });
    setTimeout(() => setNotification({ show: false, message: '', type: '' }), 3000);
  };

  // Fetch all projects
  const fetchProjects = async () => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem('Token');
      const roll_id = user.currentUser.rollId;
      const response = await axios.get(`${backendURL}/project/${roll_id}`, {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        withCredentials: true,
      });

      const projectData = Array.isArray(response.data) ? response.data : [];

      setProjects(projectData.filter(p =>
        p.status === 'FALSE' && p.done_review === 'FALSE' &&
        p.publish === 'FALSE' && p.under_review === 'FALSE'
      ));
      setPublishedProjects(projectData.filter(p => p.publish === 'TRUE'));
      setUnderReviewProjects(projectData.filter(p => p.under_review === 'TRUE'));

      setLoading(false);
    } catch (err) {
      console.error('Error fetching projects:', err);
      setError('Failed to load projects.');
      setLoading(false);
    }
  };

  // Delete student from a published project
  const deleteStudentFromProject = async (faculty_id, project_id, student_id) => {
    try {
      setDisableActions(true);
      const token = sessionStorage.getItem('Token');
      const res = await axios.delete(
        `${backendURL}/faculty/${faculty_id}/project/${project_id}/student/${student_id}`,
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      );

      if (res.status === 200) {
        setPublishedProjects(prev =>
          prev.map(project =>
            project.project_id === project_id
              ? { ...project, students: project.students.filter(s => s.student_id !== student_id) }
              : project
          )
        );
        showNotification('Student removed successfully');
      }
    } catch (err) {
      console.error('Error deleting student:', err);
      showNotification('Failed to remove student', 'error');
    } finally {
      setDisableActions(false);
    }
  };

  // Handle component mount
  useEffect(() => {
    fetchProjects();
  }, [user.currentUser.id]);

  // Delete project
  const handleDelete = async (id) => {
    try {
      setDisableActions(true);
      const token = sessionStorage.getItem('Token');
      const res = await axios.delete(`${backendURL}/delete_project/${id}`, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });

      if (res.data.message === "Project deleted successfully!") {
        setProjects(projects.filter(p => p.project_id !== id));
        showNotification('Project deleted successfully');
      }

      setDeleteConfirmModal({ show: false, id: null });
    } catch (err) {
      console.error('Error deleting project:', err);
      showNotification('Failed to delete project', 'error');
    } finally {
      setDisableActions(false);
    }
  };

  // Edit project
  const handleEdit = (project) => setEditProject({ ...project });

  // Cancel edit
  const handleCancelEdit = () => setEditProject(null);

  // Save edited project
  const handleSave = async () => {
    try {
      setDisableActions(true);
      const token = sessionStorage.getItem('Token');
      const data = { project_data: editProject, user_info: user.currentUser };
      const res = await axios.put(`${backendURL}/update_project`, data, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });

      if (res.status === 200) {
        setProjects(prev => prev.map(p => p.project_id === editProject.project_id ? editProject : p));
        setEditProject(null);
        showNotification('Project updated successfully');
      }
    } catch (err) {
      console.error('Error saving project:', err);
      showNotification('Failed to update project', 'error');
    } finally {
      setDisableActions(false);
    }
  };

  // Send project for review
  const handleReview = async (project) => {
    try {
      setDisableActions(true);
      const token = sessionStorage.getItem('Token');
      const res = await axios.post(
        `${backendURL}/under_review`,
        { under_review: true, currentUser: user.currentUser, project: project },
        { headers: { 'Content-Type': 'application/json' }, withCredentials: true }
      );

      if (res.data.message === 'sent email wait for review!') {
        const updatedProject = { ...project, under_review: 'TRUE' };
        setProjects(prev => prev.filter(p => p.project_id !== project.project_id));
        setUnderReviewProjects(prev => [...prev, updatedProject]);
        showNotification('Project submitted for review');
      }
    } catch (err) {
      console.error('Error marking as under review:', err);
      showNotification('Failed to submit for review', 'error');
    } finally {
      setDisableActions(false);
    }
  };

  // Navigate to upload page
  const handleAddClick = () => navigate('/fileUpload');

  // Navigate to review page
  const handleViewReviews = (project) => navigate(`/reviewPage/${project.project_id}`);

  return (
    <div className="edit-delete-publish-dashboard">
      {/* Notifications */}
      {notification.show && (
        <div className={`notification ${notification.type}`}>
          {notification.message}
        </div>
      )}

      {/* Header */}
      <h2 className="text-center text-2xl font-bold mb-6">PROJECT MANAGEMENT DASHBOARD</h2>
      <p>Total Draft Projects: {projects.length}</p>

      {/* Add & Research buttons */}
      <div className="d-flex justify-content-between mb-4">
        <button className="add text-white bg-success" onClick={handleAddClick} disabled={disableActions}>
          Add New Project
        </button>
        <button className="research text-white bg-success" disabled={disableActions}>
          Research / Explore
        </button>
      </div>

      {/* Tabs */}
      <div className="flex space-x-6 justify-center mb-6 mt-2">
        {[
          { key: 'draft-projects', label: 'Draft Projects' },
          { key: 'under-review', label: 'Projects Under Review' },
          { key: 'published-projects', label: 'Approved Projects' }
        ].map(tab => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`text-lg font-semibold ${
              activeTab === tab.key ? "text-blue-600 underline" : "text-gray-700"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="bg-gray-100 p-6 rounded-md shadow-md">
        {/* Draft Projects */}
        {activeTab === "draft-projects" && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {projects.length > 0 ? (
              projects.map(project => (
                <div key={project.project_id} className="project-card1 slide-in">
                  <div className="project-info">
                    <h2><strong>{project.title}</strong></h2>
                    <p><strong>Abstract:</strong> {project.abstract}</p>
                    <p><strong>Requirements:</strong> {project.requirements}</p>
                    <p><strong>Domain:</strong> {project.domain}</p>
                    <p><strong>Department:</strong> {project.department}</p>
                    {project.students?.length > 0 ? (
                      <ul>
                        {project.students.map(student => (
                          <li key={student.id}>
                            {student.name} - {student.email} (ID: {student.student_id})
                          </li>
                        ))}
                      </ul>
                    ) : <p>No students assigned.</p>}
                  </div>

                  <div className="buttonns">
                    <div className="project-actions1">
                      <button onClick={() => handleEdit(project)} className="edit-btn" disabled={disableActions}>
                        Edit
                      </button>
                      <button
                        onClick={() => setDeleteConfirmModal({ show: true, id: project.project_id })}
                        className="delete-btn"
                        disabled={disableActions}
                      >
                        Delete
                      </button>
                    </div>
                    <div className="project-actions1">
                      <button
                        onClick={() => handleReview(project)}
                        className="publish-btn"
                        disabled={disableActions}
                      >
                        Submit for Review
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-projects">
                <h3>No Draft Projects Available</h3>
                <p>Click "Add New Project" to create a project.</p>
              </div>
            )}
          </div>
        )}

        {/* Projects Under Review */}
        {activeTab === "under-review" && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {underReviewProjects.length > 0 ? (
              underReviewProjects.map(project => (
                <div key={project.project_id} className="project-card slide-in">
                  <div className="project-info reviews">
                    <h2>{project.title}</h2>
                    {project.abstract && <p><strong>Abstract:</strong> {project.abstract}</p>}
                    {project.requirements && <p><strong>Requirements:</strong> {project.requirements}</p>}
                    {project.domain && <p><strong>Domain:</strong> {project.domain}</p>}
                    {project.department && <p><strong>Department:</strong> {project.department}</p>}
                    <button
                      onClick={() => handleViewReviews(project)}
                      className="button btn-success"
                      disabled={disableActions}
                    >
                      View Feedback
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-projects">
                <h3>No Projects Under Review</h3>
                <p>Submit projects for review from the Draft Projects tab.</p>
              </div>
            )}
          </div>
        )}

        {/* Approved Projects */}
        {activeTab === "published-projects" && (
          <div className="published-project-list">
            {publishedProjects.length > 0 ? (
              publishedProjects.map(project => (
                <div key={project.project_id} className="project-card">
                  <div className="project-info">
                    <h2>{project.title}</h2>
                    {project.abstract && <p><strong>Abstract:</strong> {project.abstract}</p>}
                    {project.requirements && <p><strong>Requirements:</strong> {project.requirements}</p>}
                    {project.domain && <p><strong>Domain:</strong> {project.domain}</p>}
                    {project.department && <p><strong>Department:</strong> {project.department}</p>}
                    {project.students?.length > 0 ? (
                      <>
                        <p><strong>Students:</strong></p>
                        <ul>
                          {project.students.map(student => (
                            <div key={student.id} className="flex gap-3 text-lg">
                              <li>{student.name} - {student.email} (ID: {student.student_id})</li>
                              <button
                                className="bg-red-500 rounded-md p-2"
                                onClick={() => deleteStudentFromProject(user.currentUser.rollId, project.project_id, student.student_id)}
                                disabled={disableActions}
                              >
                                Remove
                              </button>
                            </div>
                          ))}
                        </ul>
                      </>
                    ) : <p><strong>Students:</strong> No students assigned</p>}
                    <button
                      className="view-reviews"
                      onClick={() => handleViewReviews(project)}
                      disabled={disableActions}
                    >
                      View Feedback
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-projects">
                <h3>No Approved Projects</h3>
                <p>Projects that pass review will appear here.</p>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Edit Modal */}
      <Modal show={!!editProject} onHide={handleCancelEdit} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editProject && (
            <div className="project-edit-form">
              <div className="form-group">
                <label>Title</label>
                <input
                  type="text"
                  value={editProject.title}
                  onChange={(e) => setEditProject({ ...editProject, title: e.target.value })}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label>Abstract</label>
                <textarea
                  value={editProject.abstract}
                  onChange={(e) => setEditProject({ ...editProject, abstract: e.target.value })}
                  rows="3"
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label>Requirements</label>
                <input
                  type="text"
                  value={editProject.requirements}
                  onChange={(e) => setEditProject({ ...editProject, requirements: e.target.value })}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label>Domain</label>
                <input
                  type="text"
                  value={editProject.domain}
                  onChange={(e) => setEditProject({ ...editProject, domain: e.target.value })}
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label>Department</label>
                <input
                  type="text"
                  value={editProject.department}
                  onChange={(e) => setEditProject({ ...editProject, department: e.target.value })}
                  className="form-control"
                />
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelEdit} disabled={disableActions}>Cancel</Button>
          <Button variant="primary" onClick={handleSave} disabled={disableActions}>Save Changes</Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal show={deleteConfirmModal.show} onHide={() => setDeleteConfirmModal({ show: false, id: null })} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this project?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDeleteConfirmModal({ show: false, id: null })}>Cancel</Button>
          <Button variant="danger" onClick={() => handleDelete(deleteConfirmModal.id)} disabled={disableActions}>Delete</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EditDeletePublish;

